import { Select, SelectProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { taskList } from '../service';
import { useMount } from 'ahooks';
import { useTaskContext } from './context';
import { useGetTaskName } from 'views/Aide/Basis/Todo/TaskTable';

export interface TaskSelectProps extends Omit<SelectProps<any>, 'onChange'> {
  onChange: (value: any) => void;
}

const TaskSelect = (props: TaskSelectProps) => {
  const { value: valueProp, onChange: onChangeProp, onBlur, onClear, ...otherProps } = props;
  const { getTaskName } = useGetTaskName();

  const { list, loading, fetchList } = useCrud({
    readList: taskList,
  });
  const { setValue: setStore } = useTaskContext();

  useMount(() => {
    fetchList()
      .then((res) => {
        onChangeProp(res?.[0]?.id);
        setStore(res?.[0]?.storeList);
      })
      .catch(() => {});
  });

  return (
    <Select
      dropdownMatchSelectWidth={false}
      loading={loading}
      value={String(valueProp)}
      onChange={(value) => {
        onChangeProp(value);
        setStore(list?.find((each) => each.id === Number(value))?.storeList || []);
      }}
      {...otherProps}
    >
      {list?.map((each) => {
        return (
          <Select.Option key={each.id} value={String(each.id)}>
            {getTaskName(each)}
          </Select.Option>
        );
      })}
    </Select>
  );
};

export default TaskSelect;
